export function localAsUTC(date: Date | undefined): Date {
    if (date instanceof Date) {
        return new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000)
    }
    return new Date(0)
}
